var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.sections),function(section,index){return _c('ContentGeneratorSection',{key:index,attrs:{"section":section}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }